import { hardcodedPersons as personConfig } from '../../../../server/src/common/prompts/generationPrompts.json';
import { createNewPresentation } from '../actions/newPresentation';
import { first, firstValueFrom, map } from 'rxjs';

const person = personConfig.storyteller;

export function createStory(title: string) {
    return firstValueFrom(
        createNewPresentation({
            kind: 'STORY',
            contentModeration: true,
            createCoverSlideVideo: false,
            createSpeakerVideo: false,
            imageGeneratorName: 'stable-diffusion-xl',
            language: 'German',
            numberOfSlides: 5,
            person,
            promotion: 'none',
            textGeneratorName: 'openai-gpt4',
            title,
        }).pipe(
            map((event) => {
                switch (event.type) {
                    case 'created-presentation':
                        return event.url;
                    case 'error':
                    case 'abort':
                        throw new Error(event.message);
                    case 'quota':
                        throw new Error(event.type);
                    default:
                        return undefined;
                }
            }),
            first((url): url is string => Boolean(url)),
            map((url) => {
                const match = /presentations\/(\d+)\/.*/.exec(url);
                if (!match) {
                    throw new Error('Could not extract presentation id');
                }
                return match[1];
            })
        )
    );
}
